import React, { useContext } from 'react';
import { CategoriasContext } from '../../context/CategoriasContext';

function ItemCategoria({ item, isLast, index, caminoCategoria }) {
  const { actualizarCategorias } = useContext(CategoriasContext);
  
  const handleCargaCategoria = () => {
    const nuevoCaminoCategoria = caminoCategoria.slice(0, -1);
    actualizarCategorias(nuevoCaminoCategoria);
  }

  return (
    <div className='mx-2'>
      {isLast ? (
        // Si es el último, no se muestra como un enlace y se pone en verde
        <label className='text-2xs lg:text-base text-Verde'>
          {item.nombre}
        </label>
      ) : (
        // Si no es el último, es un enlace (usamos button en lugar de Link)
        <label className='text-2xs lg:text-base'>
          <button onClick={handleCargaCategoria}>{item.nombre}</button>
        </label>
      )}
    </div>
  );
}

export default ItemCategoria;